import Yup from 'yup';

export const numberType = Yup.string()
  .nullable()
  .max(7, 'This number is too long.')
  .test('is-number', 'This field must be a number.', num => !isNaN(num));
export const requiredNumberType = numberType.required('This field is required.');

export const stringType = Yup.string()
  .nullable()
  .max(255, 'This text is too long.');
export const requiredStringType = stringType.ensure().required('This field is required.');

export const requiredAutocompleteType = stringType
  .ensure()
  .required('Please select from the result list.');

export const textType = Yup.string()
  .nullable()
  .max(65535, 'This text is too long.');
export const requiredTextType = textType.ensure().required('This field is required.');

export const requiredEmailType = requiredStringType.email('This is not a valid email address.');

export const urlType = stringType.url('This is not a valid URL.');
export const requiredUrlType = requiredStringType.url('This is not a valid URL.');

export const dateType = Yup.date()
  .nullable()
  .min('1800', 'This date is invalid.')
  .max('2100', 'This date is invalid.')
  .typeError('This date is invalid.');
export const requiredDateType = dateType.required('This field is required.');

/* RegEx for phone numbers are from O'Reilly's Regular Expressions Cookbook, 2nd Edition
Domestic: https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s02.html
International: https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s03.html
- SHK 6/18/19 */
const international = /^\+(?:[0-9] ?){6,14}[0-9]$/;
const domestic = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

export const intlPhoneType = Yup.string()
  .ensure()
  .matches(international, {
    message: 'Invalid international phone number',
    excludeEmptyString: false
  });
export const reqIntlPhoneType = intlPhoneType.required('This field is required.');

export const domPhoneType = Yup.string()
  .ensure()
  .matches(domestic, {
    message: 'Invalid domestic phone number',
    excludeEmptyString: false
  });
export const reqDomPhoneType = domPhoneType.required('This field is required.');

export const phoneType = Yup.string()
  .ensure()
  .test('Phone', 'Invalid phone number.', value => {
    if (!value) return false;
    if (value.match(domestic)) return true;
    if (value.match(international)) return true;
    if (!value.match(domestic) || !value.match(international)) return false;
  });

export const reqPhoneType = phoneType.required('This field is required.');

/* LinkedIn URL RegEx is edited from https://github.com/lorey/social-media-profiles-regexs
The original LinkedIn RegEx for Public URLs was "http(s)?:\/\/([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+\/?"
I made the "http(s)://" optional - SHK 6/18/19 */
export const linkedinUrlType = Yup.string()
  .ensure()
  .matches(/(http(s))?(:\/\/)?([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+\/?/, {
    message: 'Invalid LinkedIn Profile URL.',
    excludeEmptyString: false
  });
export const requiredLinkedinUrlType = linkedinUrlType.required('Invalid LinkedIn Profile URL.');
